import { render, staticRenderFns } from "./bwgzy.vue?vue&type=template&id=ed8a9942&scoped=true"
import script from "./bwgzy.vue?vue&type=script&lang=js"
export * from "./bwgzy.vue?vue&type=script&lang=js"
import style0 from "./bwgzy.vue?vue&type=style&index=0&id=ed8a9942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8a9942",
  null
  
)

export default component.exports